// frontend/src/lib/currency.js
export const EURO_RATE = 1.95583;

export const EUR_BASE_START = new Date("2026-01-01T00:00:00");
export const EUR_ONLY_START = new Date("2026-02-01T00:00:00");

export function getPhase(now = new Date()) {
  if (now < EUR_BASE_START) return "BGN_ONLY";
  if (now < EUR_ONLY_START) return "DUAL_DISPLAY";
  return "EUR_ONLY";
}

export function baseCurrency(now = new Date()) {
  return getPhase(now) === "BGN_ONLY" ? "BGN" : "EUR";
}

export function eurToBgn(eur) {
  const n = Number(eur || 0);
  return Math.round(n * EURO_RATE * 100) / 100;
}

export function bgnToEur(bgn) {
  const n = Number(bgn || 0);
  return Math.round((n / EURO_RATE) * 100) / 100;
}

export function formatMoney(amount, currency) {
  const n = Number(amount || 0);
  const v = n.toFixed(2);
  if (currency === "EUR") return `€${v}`;
  return `${v} лв`;
}

// Show EUR as main after 01.01.2026, but (≈ BGN) during January.
export function formatMainWithSecondary(amount, now = new Date()) {
  const phase = getPhase(now);
  if (phase === "BGN_ONLY") return formatMoney(amount, "BGN");
  const eur = Number(amount || 0);
  const eurText = formatMoney(eur, "EUR");
  if (phase === "DUAL_DISPLAY") {
    const bgn = eurToBgn(eur);
    return `${eurText} (≈ ${formatMoney(bgn, "BGN")})`;
  }
  return eurText;
}
